module.exports = __webpack_public_path__ + "img/cover.193de43c.jpg";